<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Password</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">

            <div class="row">
              <div class="col-sm-5 col-sm-offset-2">
                <form class="form-horizontal" submit="#">
                  <div class="form-group" v-if="!isCreation" v-bind:class="{ 'has-error': this.$v.$dirty && this.$v.previousPassword.$invalid }" >
                    <label class="control-label col-sm-3">Previous Password</label>
                    <div class="col-sm-8">
                      <input type="password" class="form-control" placeholder="" v-model="previousPassword"/>
                    </div>
                  </div>
                  <div class="form-group" v-bind:class="{ 'has-error': this.$v.$dirty && this.$v.password.$invalid }" >
                    <label class="control-label col-sm-3">New Password</label>
                    <div class="col-sm-8">
                      <input type="password" class="form-control" v-model="password"/>
                    </div>
                  </div>
                  <div class="form-group" v-bind:class="{ 'has-error': this.$v.$dirty && this.$v.confirmPassword.$invalid }" >
                    <label class="control-label col-sm-3">Confirmation</label>
                    <div class="col-sm-8">
                      <input type="password" class="form-control" v-model="confirmPassword"/>
                    </div>
                  </div>
                  <div class="form-group" >
                    <button type="button" class="btn btn-default col-sm-offset-5">Cancel</button>
                    <button v-on:click="savePassword" type="button" class="btn btn-danger col-sm-offset-1">Create</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
            <!-- /.box-body -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules
import api from '../../api'
import { required, requiredUnless, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'Cases',
  data () {
    return {
      previousPassword: null,
      password: null,
      confirmPassword: null
    }
  },
  computed: {
    isCreation () {
      return true // some conditional logic here...
    }
  },
  validations: {
    previousPassword: {
      required: requiredUnless(function (model) {
        return this.isCreation
      })
    },
    password: { required },
    confirmPassword: { required, sameAsPassword: sameAs('password') }
  },
  methods: {
    savePassword () {
      this.$v.$touch()
      if (this.$route.query.token && !this.$v.$invalid) {
        if (this.isCreation) {
          const body = {
            token: this.$route.query.token,
            password: this.password,
            confirmPassword: this.confirmPassword
          }
          return api.request('post', `/users/${this.$route.params.id}/password`, body)
            .then(response => {
              this.$router.push({ path: '/login' })
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    }
  }
}
</script>
<style>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'Font Awesome 5 Free';
}

.clickable {
    cursor: pointer;
}

table.dataTable thead .active:after {
    opacity: 0.5!important;
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
  opacity: 0.2;
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
  opacity: 0.2;
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
  opacity: 0.2;
}

.vertical-align-center {
  display: flex;
  align-items: center;
}

.new-btn {
  justify-content: center !important;
  margin: auto !important;
}

.search-btn:active:focus,
.new-btn:active:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// Password.vue?061df96d